import { createFileRoute } from '@tanstack/react-router'
import { BrandPreview, type Concept } from '@/features/brand-preview/index.ts'

export const Route = createFileRoute('/brand-preview')({
  validateSearch: (search: Record<string, unknown>): { version: Concept } => ({
    version:
      search.version === 'a' ||
      search.version === 'b' ||
      search.version === 'c' ||
      search.version === 'd' ||
      search.version === 'e'
        ? search.version
        : 'selected'
  }),
  component: BrandPreviewPage,
  head: () => ({
    meta: [{ title: 'Logo 与登录页精选优化稿 · Super Mega' }, { name: 'robots', content: 'noindex' }]
  })
})

function BrandPreviewPage() {
  const { version } = Route.useSearch()
  return <BrandPreview version={version} />
}
